@if (newEditor.show) {
<app-new-editor
  #newEditorRef
  [template]="templateData"
  [variables]="variables"
  [title]="'Landing Page Editor'"
  (EditorStateChanged)="onEditorStateChanged($event)"></app-new-editor>
}

<div class="right-content" [class.landing-preview-mode]="newEditor.active" [style.marginLeft.px]="panelCollapsed ? 0 : panelWidth" style="transition: margin-left 0.3s;">
  <app-page-shell variant="wizard" [stickyChrome]="true" [withOps]="true">
  <div pageChrome>
    <app-status-bar [loading]="(loader$ | async) || !isTemplateLoaded()" [step]="step"
                      (SaveButtonClick)="onSaveButtonClick()"></app-status-bar>
    @if (newEditor.active) {
    <div class="card landing-preview-nav">
      <app-preview-influencer-nav [name]="previewNavigation.name" [index]="previewNavigation.page - 1"
                                  [total]="previewNavigation.total" [loading]="previewNavigation.loading" emptyLabel="Preview"
                                  (previous)="onPreviewPage(previewNavigation.page - 1)"
                                  (next)="onPreviewPage(previewNavigation.page + 1)"></app-preview-influencer-nav>
    </div>
    }
  </div>
<div [style.min-height]="newEditor.active ? 'unset' : null">
@if (newEditor.active && !newEditor.show) {
<div class="card landing-preview-card">
  <app-new-editor-preview #landingPreview (OnTemplateLoaded)="templateLoaded($event)" [template]="templateData"
                          [influencerPreview]="true" [hostNavigation]="true"
                          (navigationChange)="previewNavigation = $event"></app-new-editor-preview>
</div>
}
      @if (!newEditor.active) {
      <app-template-editor
        [panelCollapsed]="panelCollapsed"
        [panelWidth]="panelWidth"
        [template]="template" [viewportSize]="viewportSize"
        (OnTemplateLoaded)="templateLoaded($event)"
        [isLoading]="(loader$ | async)"
        [showLandingPageEnable]="false"
        [(landingPageEnabled)]="landingPageEnabled"
        (OnPageSettingsChanged)="onStylesCustomizationChange($event)"
        (OnContentChanged)="onContentChanged()"
        #templateEditor [pageSetting]="stylesForm.value" [variables]="getVariables()"
        (OnTemplateTypeChange)="fetchRawTemplatesById($event)" [templateType]="'landing'" [showTemplateSelector]="false" [showBlockSelector]="true"
        [rawTemplatesTypes]="rawTemplatesTypes" [templates]="templates"></app-template-editor>
      }
</div>
</app-page-shell>
</div>

@if (!panelCollapsed && !newEditor.active) {
<div class="toolbar-panel-resize-handle"
     [style.left]="panelWidth + 'px'"
     (pointerdown)="startResizing($event)">
</div>
}
@if (!newEditor.active) {
<button class="toolbar-panel-toggle-button"
        [style.left]="(panelCollapsed ? 0 : panelWidth) + 'px'"
        (click)="togglePanel()">
  {{ panelCollapsed ? '▶' : '◀' }}
</button>
}

<div class="operation-box">
  <div class="col-md-12">
    <div class="row align-items-center">
      <div class="col-md-6 p-0">
        <div class="text-start">
          <button [disabled]="(loader$ | async) || !isTemplateLoaded()" (click)="onBackButtonClick()" class="btn btn-default me-2" type="button">
            Back
          </button>


          <div class="btn-group dropup me-2" ngbDropdown placement="top-start">
            @if (!newEditor.active) {
            <button type="button"
                    [disabled]="(loader$ | async) || !isTemplateLoaded()"
                    class="btn btn-default dropdown-toggle"
                    ngbDropdownToggle aria-haspopup="true">
              Template
            </button>
            }
            <div class="dropdown-menu border-rad-10x" ngbDropdownMenu>
              <button [disabled]="(loader$ | async) || !isTemplateLoaded()" (click)="onBackButtonClick(true)" class="dropdown-item" type="button">
                Change template
              </button>
              <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -- ids and codes arrive as numbers or strings -->
              @if (templateTypeId == 1) {
              <button [disabled]="(loader$ | async) || !isTemplateLoaded() || !this.template?.id"
                      class="dropdown-item"
                      (click)="saveAsNewTemplateModel(saveAsTemplate, 'client')">
                Save as new template
              </button>
              }
              <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -- ids and codes arrive as numbers or strings -->
              @if (currentUser?.can('view-advanced-editor', 'template') && templateTypeId == 1) {
              <button [disabled]="(loader$ | async) || !isTemplateLoaded() || !this.template?.id"
                      class="dropdown-item"
                      (click)="saveAsNewTemplateModel(saveAsTemplate, 'public')">
                Save as new public template
              </button>
              }
            </div>
          </div>

          <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -- ids and codes arrive as numbers or strings -->
          @if (templateTypeId == 1) {
          <button [disabled]="(loader$ | async) || !isTemplateLoaded()"
                  class="btn btn-default me-2"
                  (click)="showTemplateRevisions()">
            Undo All
          </button>
          }
          @if (this.template?.id) {
          <button [disabled]="!isTemplateLoaded()"
                  class="btn btn-default"
                  (click)="showNewEditor()">
            {{ newEditor.active ? 'Edit' : 'Edit In New Editor' }}
          </button>
          }
        </div>
      </div>
      <div class="col-md-3 d-flex p-0">
        @if (!newEditor.active) {
        <app-device-toolbar
          (onPageSizeChange)="onPageSizeSelect($event)"
          (openCodeEditor)="onEditHtml()"></app-device-toolbar>
        }
      </div>
      <div class="col-md-3 p-0">
        <div class="text-end">
          <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -- ids and codes arrive as numbers or strings -->
          @if (templateTypeId == 1) {
          <button [disabled]="(loader$ | async) || !isTemplateLoaded()"
                  class="btn btn-default btn me-2"
                  (click)="onPreviewButtonClick()">
            <span>@if ((loader$ | async) || !isTemplateLoaded()) {
<i class="fa fa-spinner fa-spin me-2"></i>
}Preview</span>
          </button>
          }
          <button [disabled]="(loader$ | async) || !isTemplateLoaded()" (click)="onNextButtonClick()"
                  class="btn btn-primary btn">
            <span>@if ((loader$ | async) || !isTemplateLoaded()) {
<i class="fa fa-spinner fa-spin me-2"></i>
}Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #saveAsTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Save template as</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="saveTemplateForm">
      <div class="row">
        <div class="col-md-12">
          <div class='input-group input-group-sm'>
            <input class="form-control" formControlName="saveAsTemplateName" placeholder="Template Name" [style]="{background: 'none'}"
                   type="text" [class.is-invalid]="saveAsTemplateNameSubmit && !saveAsTemplateName">
          </div>
          @if (!saveAsTemplateName && saveAsTemplateNameSubmit) {
          <div class="bar error-brd">
            <div class="invalid-text">Enter template name</div>
          </div>
          }
        </div>
      </div>

      <div class="row my-2">
        <div class="col-md-12">
          <div class="d-flex align-items-center">
            <small>Influencer Type</small>
          </div>
          <div class='input-group input-group-sm'>
            <select class="floating-select" formControlName="influencer_type_id" (ngModelChange)='changingInfluencerType($event)'>
              @for (influencerType of influencerTypes; track influencerType) {
              <option [value]='influencerType.id'
                     >{{influencerType.name}}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
    <button type="button" class="btn btn-primary" (click)="saveAsNewTemplate(modal)">Submit</button>
  </div>
</ng-template>
